import { render } from "./DocumentCardCheckbox.vue?vue&type=template&id=af987500&scoped=true&ts=true"
import script from "./DocumentCardCheckbox.vue?vue&type=script&lang=ts"
export * from "./DocumentCardCheckbox.vue?vue&type=script&lang=ts"

import "./DocumentCardCheckbox.vue?vue&type=style&index=0&id=af987500&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af987500"]])

export default __exports__